import { contrastChart } from '@iq/react-components';
import { resolveColor } from '../../../../../../colors';

const RollingAveragePlot = ({ rollingPlot, configuration }) => (
  <g
    name="rolling-plot"
    style={{ pointerEvents: 'none' }}
  >
    {rollingPlot.data.length > 0 &&
      rollingPlot.data.map((value, index) => {
        if (configuration.rollingAverage?.type === 'Lines') {
          if (index === rollingPlot.data.length - 1) {
            return null;
          }
          return (
            <line
              key={index}
              x1={value.X}
              y1={value.Y}
              x2={rollingPlot.data[index + 1].X}
              y2={rollingPlot.data[index + 1].Y}
              stroke={resolveColor(rollingPlot.color) || contrastChart[1]}
              strokeWidth={configuration.pointRadius / 3}
              opacity={((100 / rollingPlot.data.length) * index) / 100}
            />
          );
        }
        if (configuration.rollingAverage?.type === 'Both') {
          return (
            <g key={index}>
              {index !== rollingPlot.data.length - 1 && (
                <line
                  x1={value.X}
                  y1={value.Y}
                  x2={rollingPlot.data[index + 1].X}
                  y2={rollingPlot.data[index + 1].Y}
                  stroke={resolveColor(rollingPlot.color) || contrastChart[1]}
                  strokeWidth={configuration.pointRadius / 3}
                  opacity={((100 / rollingPlot.data.length) * index) / 100}
                />
              )}
              <circle
                cx={value.X}
                cy={value.Y}
                r={configuration.pointRadius / 2}
                opacity={((100 / rollingPlot.data.length) * index) / 100}
                fill={resolveColor(rollingPlot.color) || contrastChart[1]}
                stroke=""
              />
            </g>
          );
        }

        return (
          <circle
            key={index}
            cx={value.X}
            cy={value.Y}
            r={configuration.pointRadius / 2}
            opacity={((100 / rollingPlot.data.length) * index) / 100}
            fill={resolveColor(rollingPlot.color) || contrastChart[1]}
            stroke=""
          />
        );
      })}
  </g>
);

export default RollingAveragePlot;
